import { useEffect, useMemo, useState } from "react";
import View360, { EquirectProjection } from "@egjs/react-view360";
import styled from "styled-components";
import SwipeIcon from '../../icons/SwipeIcon.svg?react';

interface Viewer360Props{
    url: string;
}

const Viewer360: React.FC<Viewer360Props> = (p) => {

    const [activeOverlay, setActiveOverlay] = useState<boolean>(true);

    const projection = useMemo(() => new EquirectProjection({
        src : p.url
    }), [p.url]);

    useEffect(() => {
        setActiveOverlay(true);
        setInterval(() => setActiveOverlay(false), 4000)
    }, [])
    
    return (
        <Container>
            <Overlay $active={activeOverlay}>
                <SwipeIcon width={128} height={128}/>
                <OverlayText>Naviguez dans la scène en utilisant votre curseur</OverlayText>
            </Overlay>
            <View360
                className="is-16by9"
                projection={projection}
            />
        </Container>
    )
}

const Overlay = styled.div<{$active: boolean}>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0, .5);
    opacity: ${({$active}) => $active ? "1" : "0"};
    z-index: 400;
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    transition: opacity .5s ease-in-out;
    & svg path {
        fill: white;
    }
`

const OverlayText = styled.div`
    color: #fff;
    font-family: Poppins-Medium, sans-serif;
    font-size: 18px;
`

const Container = styled.div`
    position: relative;
    width : calc(min(100vh/9*16, 100vw));
    height : calc(min(100vh, 100vw/16*9));
    user-select: none;
    & canvas{
        width : calc(min(100vh/9*16, 100vw));
        height : calc(min(100vh, 100vw/16*9));
    }
`

export default Viewer360;